export type EntityOverrideOffer = {
  entityId: string;
  category: string;
};

/**
 * After a page-badge save, offer an entity override only for a one-page
 * entity whose effective category differs from the new label.
 */
export function shouldOfferEntityOverride(input: {
  savedCategory: string | null;
  reconstructedList: { items: { id: string }[]; hasNext: boolean } | null;
  entity: {
    id: string;
    pages: readonly unknown[];
    userSuggestedCategory: string | null;
    classification: string;
  } | null;
}): EntityOverrideOffer | null {
  const { savedCategory, reconstructedList, entity } = input;
  if (savedCategory === null) return null;
  if (reconstructedList === null) return null;
  if (reconstructedList.hasNext || reconstructedList.items.length !== 1) return null;
  if (entity === null || entity.id !== reconstructedList.items[0].id) return null;
  if (entity.pages.length !== 1) return null;
  const effective = entity.userSuggestedCategory ?? entity.classification;
  if (effective === savedCategory) return null;
  return { entityId: entity.id, category: savedCategory };
}
